import { IconType } from "react-icons";

export interface Project {
  id: string;
  name: string;
  description: string;
}

export interface Feature {
  id: string;
  name: string;
  description?: string;
  status: "active" | "inactive";
  defaultTreatment: string;
  treatments: Treatment[];
  targeting: TargetingRule[];
  individualTargets: IndividualTarget[];
  projectId: string;
  createdAt: string;
  updatedAt: string;
}

export interface Treatment {
  name: string;
  description?: string;
  isDefault?: boolean;
}

export interface TargetingRule {
  id: string;
  condition: string;
  treatment: string;
  percentage?: number;
}

export interface IndividualTarget {
  userId: string;
  treatment: string;
}

export interface Segment {
  id: string;
  name: string;
  description: string;
  projectId: string;
}

export interface ProjectStats {
  totalFeatures: number;
  activeFeatures: number;
  totalSegments: number;
  activeSegments: number;
}

export interface CreateProjectPayload {
  projectName: string;
  projectDescription: string;
  contextName: string;
  contextDescription: string;
}

export interface CreateProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export interface ProjectCardProps {
  project: Project;
}

export interface StatCardProps {
  icon: IconType;
  value: number;
  title: string;
  description?: string;
}

export interface FeatureCardProps {
  feature: Feature;
  onClick: (featureId: string) => void;
}

export interface FeatureFlipProps {
  projects: Project[];
  stats: {
    [projectId: string]: ProjectStats;
  };
  onCreateProject: (data: CreateProjectPayload) => void;
  onProjectClick: (projectId: string) => void;
}

export interface FeatureDetailsProps {
  feature: Feature;
  onUpdate: (feature: Feature) => void;
  isLoading?: boolean;
}

export interface SegmentDetailsProps {
  segment: Segment;
  onUpdate: (segment: Segment) => void;
  isLoading?: boolean;
}


export interface Context {
  id: string;
  name: string;
  description: string;
}

export type FeatureType = "RELEASE" | "EXPERIMENT" | "PERMISSION" | "OPS";

export const FEATURE_TYPE_INFO = {
  'RELEASE': 'RELEASE: Decouples deployment from release, allowing code to be deployed to production without affecting users until ready.',
  'EXPERIMENT': 'EXPERIMENT: Used for A/B testing to expose different versions of a feature to different user groups.',
  'OPS': 'OPS: Controls operational aspects of a system, useful during migrations or to manage system behavior during incidents.',
  'PERMISSION': 'PERMISSION: Controls feature access based on user segmentation, enabling fine-grained control over who can access what.'
};

export interface CreateFeaturePayload {
  featureName: string;
  featureType: FeatureType;
  enabled: boolean;
  isDynamic: boolean;
  description?: string;
}

export interface CreateTreatmentPayload {
  treatmentName: string;
  rolloutPercentage: number;
  configuration?: Record<string, string>;
  treatmentdescription?: string|null;
  default:boolean;

}


export interface CreateSegmentsPayload {
  segmentName: string;
  segmentDescription?: string;
  contextId: string | null;
  contextName: string;
  contextDescription?: string;
  contextValues?: string[];
}

